var points = 0;
var scoreText;

export class Score {
	constructor(self) {
		this.self = self;
	}

	createScoreBox() {
		const mainCam = this.self.cameras.main;
		mainCam.setBounds(0, 0, 4401, 7019); //Left, Top, X Limit, Y Limit
		mainCam.setZoom(0.6); //0.8
		mainCam.centerOn(1100, 800); //1100, 700
		var styleScore = {
			fontFamily: 'Calibri',
			fontSize: 120,
			color: '#FFFFFF',
		};
		this.self.scoreBox = this.self.add
			.image(-250, 960, 'score-box')
			.setScrollFactor(0, 0)
			.setDepth(1.1); //y=980
		scoreText = this.self.add
			.text(-250, 900, points, styleScore)
			.setScrollFactor(0, 0)
			.setDepth(1.2); //y=920
		scoreText.style.align = 'inherit';
	}

	addPoints() {
		points++;
		scoreText.text = points;
	}

	add2Points() {
		points = points + 5;
		scoreText.text = points;
	}

	add5Points() {
		points = points + 5;
		scoreText.text = points;
	}

	add10Points() {
		points = points + 10;
		scoreText.text = points;
	}

	showPoints() {
		return points;
	}
}
